import usePrivateAxios from "@/common/api/usePrivateAxios";
import { ErrorResponse } from "@/common/types/errorResponse";
import { useMutation } from "@tanstack/react-query";
import { UpdateTmaisRafflesValidationSchema } from "../schemas/tmaisRaffles.schema";
import { TmaisRaffleData } from "../types/tmaisRaffles.type";
import { getRailsUpdate } from "@/common/utils/getRailsUpdate";

interface UseUpdateTmaisRaffleProps {
  id: string
  initialTmaisRaffle?: TmaisRaffleData
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

const useUpdateTmaisRaffle = ({id, initialTmaisRaffle, onSuccess, onError}: UseUpdateTmaisRaffleProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateTmaisRaffle'],
    mutationFn: async (form: UpdateTmaisRafflesValidationSchema) => {
      const [day, month, year] = form.select_winner_at.split('/');

      const formattedSelectWinnerAt = form?.select_winner_time_at 
        ? new Date(`${year}-${month}-${day}T${form?.select_winner_time_at}:00`).toISOString() 
        : form.select_winner_at
  
      const maxTicketsPerUser = form.max_tickets_per_user ? Number(form.max_tickets_per_user.replace(/\D/g, '')) : undefined
      const selectWinnerOperationKlass = form?.select_winner_operation_klass ? form.select_winner_operation_klass.value : undefined
      const creatorEstablishmentCompanyBranchId = form?.creator_establishment_company_branch_id ? form.creator_establishment_company_branch_id.value : undefined
      
      const picturesAttachmentsAttributes = getRailsUpdate(
        initialTmaisRaffle?.pictures || [],
        form.pictures_attachments_attributes || [], 
        (photo) => photo.id, 
        (photo) => photo.id, 
        (photo) => ({ id: photo.id, _destroy: true }), 
        (photo) => ({ blob_id: photo.id })
      )

      const raffle = {
        ...form,
        max_tickets_per_user: maxTicketsPerUser,
        select_winner_operation_klass: selectWinnerOperationKlass,
        creator_establishment_company_branch_id: creatorEstablishmentCompanyBranchId,
        select_winner_at: formattedSelectWinnerAt,
        pictures_attachments_attributes: picturesAttachmentsAttributes,
      }

      return privateAxios.put(`/tmais/raffles/${id}`, { raffle })
    },
    onSuccess,
    onError
  });
}

export default useUpdateTmaisRaffle
